import React from "react";
import ClassNames from "classnames";

var SubpagePager = function SubpagePager(_ref) {
  var hasSubpages = _ref.hasSubpages,
      nextPageSlug = _ref.nextPageSlug,
      prevPageSlug = _ref.prevPageSlug,
      onClickPager = _ref.onClickPager;

  if (hasSubpages) {
    var prevBtnClassNames = ClassNames("btn", "btn--prev", {
      "btn--disabled": !prevPageSlug
    });
    var nextBtnClassNames = ClassNames("btn", "btn--next", {
      "btn--disabled": !nextPageSlug
    });
    return React.createElement("nav", {
      className: "l-pager"
    }, React.createElement("a", {
      className: prevBtnClassNames,
      href: "#".concat(prevPageSlug),
      onClick: function onClick(e) {
        return prevPageSlug ? onClickPager(e, prevPageSlug) : e.preventDefault();
      }
    }, "Previous"), React.createElement("a", {
      className: nextBtnClassNames,
      href: "#".concat(nextPageSlug),
      onClick: function onClick(e) {
        return nextPageSlug ? onClickPager(e, nextPageSlug) : e.preventDefault();
      }
    }, "Next"));
  }

  return "";
};

export default SubpagePager;